import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/core/services/user.service';
import { ResumeService } from 'src/app/modules/dashboard/services/resume.service';

@Component({
  selector: 'alert-last-created',
  templateUrl: './alert-last-created.component.html',
  styleUrls: ['./alert-last-created.component.scss']
})
export class AlertLastCreatedComponent implements OnInit {

  constructor(
    public resumeService: ResumeService,
    public router: Router,
    public userService: UserService
  ) {
    resumeService.alertLastFiveCreated.subscribe((data) => {
      this.dataSource = data;
    });
  }
  get isEmpty() {
    return this.dataSource?.length == 0 ? true : false;
  }
  dataSource;

  displayedColumns: string[] = [
    'createdAt',
    'updated',
    'gai',
    'description',
    'assigned',
  ];

  goRoute(alert) {
    if (
      alert.status != 'archived' ||
      this.userService.currentUser.role.seeArchivedCases
    )
      this.router.navigate([`/alertInfo/${alert._id}/`]);
  }
  seeArchived;
  ngOnInit() {}
}
